// extracted by mini-css-extract-plugin
export var chip = "_dw-0";
export var filterDropdown = "_dw-5";
export var filterItem = "_dw-6";
export var icon = "_dw-1";
export var removeButton = "_dw-3";
export var removeIcon = "_dw-4";
export var separator = "_dw-2";